import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { getArchive, getPdfUrl } from '../api';

const HOTELS = [
  { id: '', name: 'Все отели' },
  { id: 46844, name: 'Бутик отель Номера' },
  { id: 12076, name: 'Номера у Эрмитажа' },
  { id: 13328, name: 'Номера у Невы' },
  { id: 46850, name: 'Номера на Жуковского' },
  { id: 46851, name: 'Апартаменты Брискорн' },
  { id: 46852, name: 'Номера на Площади Восстания' },
  { id: 46894, name: 'Номера на Садовой' },
  { id: 46895, name: 'Номера на Гончарной' },
  { id: 46896, name: 'Номера на Невском 111' },
  { id: 49000, name: 'Номера на Пирогова' },
  { id: 52055, name: 'Номера на Балтийской' },
  { id: 53153, name: 'Трауберг' },
  { id: 55427, name: 'Номера на Морской' },
  { id: 56423, name: 'Номера на Фонтанке' },
];

export default function ArchivePage() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem('rc_user') || 'null');
  const today = new Date().toISOString().slice(0, 10);

  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    hotel_id: '',
    date_from: today,
    date_to: today,
    search: '',
    booking_number: '',
  });

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try {
      const params = {};
      if (filters.hotel_id)      params.hotel_id      = filters.hotel_id;
      if (filters.date_from)     params.date_from     = filters.date_from;
      if (filters.date_to)       params.date_to       = filters.date_to;
      if (filters.search)        params.search        = filters.search;
      if (filters.booking_number) params.booking_number = filters.booking_number;
      const res = await getArchive(params);
      setCards(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  function handleLogout() {
    localStorage.removeItem('rc_token');
    localStorage.removeItem('rc_user');
    navigate('/admin/login');
  }

  function formatDt(iso) {
    if (!iso) return '—';
    return new Date(iso).toLocaleString('ru-RU', {
      day: '2-digit', month: '2-digit', year: '2-digit',
      hour: '2-digit', minute: '2-digit',
      timeZone: 'Europe/Moscow'
    });
  }

  return (
    <div style={{ minHeight: '100vh', background: '#f5f5f5' }}>
      <nav className="navbar">
        <span className="navbar-brand">🏨 Рег. карты</span>
        <div className="navbar-nav">
          <Link to="/admin" className="nav-link">Заезды</Link>
          <Link to="/admin/archive" className="nav-link active">Архив</Link>
          {user?.role === 'superadmin' && (
            <Link to="/admin/guests" className="nav-link">Гости</Link>
          )}
          <button className="btn btn-outline btn-sm" onClick={handleLogout} style={{ marginLeft: 8 }}>
            Выйти
          </button>
        </div>
      </nav>

      <div className="main">
        <h1 style={{ fontSize: 22, fontWeight: 700, marginBottom: 20 }}>
          Архив карт
        </h1>

        {/* Фильтры */}
        <div className="card" style={{ marginBottom: 20 }}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12 }}>
            <div>
              <label className="label">Отель</label>
              <select
                className="input"
                value={filters.hotel_id}
                onChange={e => setFilters(f => ({ ...f, hotel_id: e.target.value }))}
              >
                {HOTELS.map(h => (
                  <option key={h.id} value={h.id}>{h.name}</option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">С</label>
              <input
                className="input" type="date"
                value={filters.date_from}
                onChange={e => setFilters(f => ({ ...f, date_from: e.target.value }))}
              />
            </div>
            <div>
              <label className="label">По</label>
              <input
                className="input" type="date"
                value={filters.date_to}
                onChange={e => setFilters(f => ({ ...f, date_to: e.target.value }))}
              />
            </div>
            <div>
              <label className="label">Поиск гостя</label>
              <input
                className="input" type="text"
                value={filters.search}
                placeholder="Имя гостя..."
                onChange={e => setFilters(f => ({ ...f, search: e.target.value }))}
              />
            </div>
            <div>
              <label className="label">Номер брони</label>
              <input
                className="input" type="text"
                value={filters.booking_number}
                placeholder="459331899..."
                onChange={e => setFilters(f => ({ ...f, booking_number: e.target.value }))}
              />
            </div>
          </div>
          <button
            className="btn btn-primary"
            style={{ marginTop: 16 }}
            onClick={load}
            disabled={loading}
          >
            {loading ? 'Загрузка...' : '🔍 Найти'}
          </button>
        </div>

        {loading ? (
          <div className="flex justify-center" style={{ padding: 60 }}>
            <div className="spinner" />
          </div>
        ) : cards.length === 0 ? (
          <div className="empty">
            <div className="empty-icon">📋</div>
            <p>Карт не найдено</p>
          </div>
        ) : (
          <div>
            <p style={{ fontSize: 14, color: '#6b7280', marginBottom: 12 }}>
              Найдено: <strong>{cards.length}</strong>
            </p>
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Гость</th>
                    <th>Отель</th>
                    <th className="hide-mobile">Бронь</th>
                    <th>Дата</th>
                    <th>PDF</th>
                  </tr>
                </thead>
                <tbody>
                  {cards.map(c => (
                    <tr key={c.id}>
                      <td><strong>{c.guest_name || '—'}</strong></td>
                      <td style={{ fontSize: 13, color: '#6b7280' }}>{c.hotel_name}</td>
                      <td className="hide-mobile" style={{ fontSize: 12, color: '#9ca3af' }}>
                        {c.booking_number?.split('-').pop()}
                      </td>
                      <td style={{ fontSize: 13 }}>{formatDt(c.signed_at)}</td>
                      <td>
                        {c.pdf_file ? (
                          <a
                            href={getPdfUrl(c.pdf_file)}
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-outline btn-sm"
                          >
                            📄 PDF
                          </a>
                        ) : '—'}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
